import React from 'react'
import Logo from "../../Reutilizables/Logo"
import MenuInicioSuscrito from './MenuInicioSuscrito'
import Profile from '../../Reutilizables/registrado/Profile'
import Redes from "../../Reutilizables/Redes"
import CargaDocumentos from '../../Reutilizables/registrado/CargaDocumento/CargaDocumentos'
import CapacitacionesInfo from '../../Reutilizables/registrado/CapacitacionesInfo'
import FechasCapacitaciones from '../../Reutilizables/registrado/FechasCapacitaciones'
import Noticias from '../../Reutilizables/registrado/noticias/Noticias'
import Footer from "../../Reutilizables/Footer"
import "../../../styles/registrado/inicioSuscrito/inicioSuscrito.css"

function InicioSuscrito({user}) {
  return (
    <>
      <div className="container-inicio-suscrito">

        <div className='inicio-suscrito-menu'>
          <Logo />
          <MenuInicioSuscrito />
        </div>

        <div className='data-perfil'>
          <Profile user = {user} />
        </div>
        
        <div className='capacitaciones-fechas'>
          <FechasCapacitaciones />
        </div>

        <div className='noticias'>
          <Noticias />
        </div>

        <div className='documentos-capacitaciones'>
          
          <div className='carga-documentos'>
            <CargaDocumentos user = {user} />
          </div>

          <div className='capacitaciones-info'>
            <CapacitacionesInfo />
          </div>

        </div>

        <div className='footer-inicio-suscrito'>
          <Footer />
        </div>
      </div>
      <Redes />
    </>
  )
}

export default InicioSuscrito